import { render, staticRenderFns } from "./SelectFilter.vue?vue&type=template&id=2ce72558&scoped=true"
import script from "./SelectFilter.vue?vue&type=script&lang=js"
export * from "./SelectFilter.vue?vue&type=script&lang=js"
import style0 from "./SelectFilter.vue?vue&type=style&index=0&id=2ce72558&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce72558",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/_work/studio-admin/studio-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ce72558')) {
      api.createRecord('2ce72558', component.options)
    } else {
      api.reload('2ce72558', component.options)
    }
    module.hot.accept("./SelectFilter.vue?vue&type=template&id=2ce72558&scoped=true", function () {
      api.rerender('2ce72558', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/filters/SelectFilter.vue"
export default component.exports